export default __webpack_public_path__ + "static/media/NovDom2023.e6274c6f.png";